/* FORM */
// Toujours compléter d'abord pas les exceptions
import { FORMS_WITH_FIELD_CONTAINER_DIV_INPUT_ONLY } from 'constants/contactForm7Constants';

export const formClasses = [
  {
    formNames: ['postuler'],
    classes: 'form-contact form-contact--postuler'
  }
];

export const fieldOnASingleRow = [
  {
    formNames: [''],
    fieldTypeList: ['email'],
    rowClasses: 'input input--material'
  },
  {
    formNames: [''],
    fieldTypeList: ['file', 'hidden'],
    rowClasses: ''
  },
  {
    formNames: [''],
    fieldTypeList: ['textarea'],
    rowClasses: 'input form-contact__textarea'
  },
  {
    formNames: [''],
    fieldTypeList: ['submit'],
    rowClasses: 'input form-action'
  }
];

export const multipleFieldsOnASingleRow = [
  {
    formNames: [''],
    fieldTypeList: ['text'],
    rowClasses: 'form-contact__row',
    divContainedInRowClasses: 'input input--material'
  },
  {
    formNames: ['emploi_candidature_spontannee'],
    fieldTypeList: ['email'],
    rowClasses: 'form-contact__row',
    divContainedInRowClasses: 'input input--material'
  },
  {
    formNames: [''],
    fieldTypeList: ['select'],
    rowClasses: 'form-contact__row',
    divContainedInRowClasses: ''
  }
];

/*  FIELDS */
export const errorClasses = {
  containerDiv: 'has-error',
  icon: 'icon-info',
  span: 'input__error'
};

export const fieldClasses = [
  {
    formNames: FORMS_WITH_FIELD_CONTAINER_DIV_INPUT_ONLY,
    fieldTypeList: ['text', 'text*', 'email', 'email*', 'number', 'number*'],
    fieldContainerDiv: 'input',
    label: '',
    input: ''
  },
  {
    formNames: [''],
    fieldTypeList: ['text', 'text*'],
    fieldContainerDiv: 'input input--material',
    label: '',
    input: ''
  },
  {
    formNames: [''],
    fieldTypeList: ['text', 'text*', 'email', 'email*', 'number', 'number*'],
    fieldContainerDiv: 'input',
    label: '',
    input: ''
  },
  {
    formNames: [''],
    fieldTypeList: ['textarea', 'textarea*'],
    fieldContainerDiv: 'input form-contact__textarea',
    label: '',
    input: ''
  },
  {
    formNames: [''],
    fieldTypeList: ['file', 'file*'],
    fieldContainerDiv: 'input--file form-contact__file',
    label: '',
    input: ''
  },
  {
    formNames: [''],
    fieldTypeList: ['select', 'select*'],
    containerDiv: 'form-contact__select',
    fieldContainerDiv: 'select js-other',
    label: '',
    input: ''
  },
  // not used just to try
  {
    formNames: [''],
    fieldTypeList: ['number', 'number*', 'date', 'date*', 'checkbox', 'checkbox*'],
    fieldContainerDiv: '',
    label: '',
    input: ''
  },
  {
    formNames: [''],
    fieldTypeList: ['checkbox', 'checkbox*'],
    containerDiv: '',
    fieldContainerDiv: 'checkbox col col-lg-4',
    label: '',
    input: ''
  },
  {
    formNames: [''],
    fieldTypeList: ['submit'],
    fieldContainerDiv: '',
    label: 'btn btn--primary js-contact-send',
    input: '',
    p: 'ft-tertiary ft-black-secondary',
    cancelButton: 'ft-500 ft-black-secondary'
  }
];
